import {useCallback, useEffect, useState} from 'react'

/**
 * Formik's `submitForm()` submits the values of the last render. A `setValues()` called right before
 * it is only seen when React has already re-rendered, which happens for a click handler but not when
 * the call runs after an `await` or a timeout (e.g. the Opn charge-status read before paying): then
 * the old values are submitted and the first Pay click silently does nothing (WBA-4300).
 *
 * The returned function asks for a submit that runs after the next commit, so it always sees the
 * values set in the same tick.
 */
export const useSubmitAfterRender = (submitForm: () => Promise<unknown>): (() => void) => {
  const [requestCount, setRequestCount] = useState(0)

  useEffect(() => {
    if (requestCount === 0) {
      return
    }
    submitForm().catch((e) => console.log(String(e)))
  }, [requestCount])

  return useCallback(() => setRequestCount((count) => count + 1), [])
}
